import { Box, Radio, Text, RadioGroup } from "@chakra-ui/react";
import { Row, Col } from "antd";
import Field from "ui/components/Input/Field";
import { useForm } from "react-hook-form";
import CardDefault from "components/Cards/CardDefault/index";
import { showErrorAxios, showSuccess } from "infra/helpers/alerta";
import useSaveParametrosUnidades from "core/features/unidades/useSaveParametrosUnidades";
import PrimaryButton from "components/Button/PrimaryButton";
import {
  ParametrosUnidadesForm,
  ParametrosUnidades,
} from "core/features/unidades/typings/unidade";
import useParametrosUnidades from "core/features/unidades/useParametrosUnidades";
import { useEffect } from "react";
import SelectContaCategoria from "ui/components/Input/SelectContaCategoria";

interface ParametrizacaoDeCobrancaProps {
  unidadeId: string;
}

export default function ParametrizacaoDeCobranca({
  unidadeId,
}: ParametrizacaoDeCobrancaProps) {
  const { data, isLoading, isFetching } = useParametrosUnidades(unidadeId);
  const { mutate: handleSave, isLoading: isLoadingSave } =
    useSaveParametrosUnidades(unidadeId);

  const handleSubmit = async (data: ParametrosUnidadesForm) => {
    const _data: ParametrosUnidades = {
      ...data,
      receberCobranca: data.receberCobranca === "s" ? true : false,
    };
    handleSave(_data, {
      onError: (e) => {
        showErrorAxios(e);
      },
      onSuccess: () => {
        showSuccess();
      },
    });
  };
  const {
    control,
    handleSubmit: _handleSubmit,
    reset,
  } = useForm<ParametrosUnidadesForm>({});

  useEffect(() => {
    if (data) {
      reset({
        ...data,
        receberCobranca:
          data.receberCobranca ||
          data.receberCobranca === null ||
          data.receberCobranca === undefined
            ? "s"
            : "n",
      });
    }
  }, [data, reset]);

  return (
    <CardDefault mb={8} bg="white" p="16px">
      <form>
        {/* <Box as={Row} gutter={16} mb={4}>
          <Box as={Col} xs={24}>
            <Field
              control={control}
              label="Pagador nos boletos"
              name="tipoVisualizacaoPagadorCobrancaId"
              render={({ field, isInvalid }) => (
                <SelectBaseAntd
                  placeholder="Selecione"
                  size="large"
                  options={getOptionsPagadorBoleto()}
                  isInvalid={isInvalid}
                  {...field}
                />
              )}
            />
          </Box>
        </Box> */}

        <Text mb={6} fontSize={18} fontWeight="bold">
          A unidade pode receber cobranças?
        </Text>

        <Box mb={4}>
          <Field
            control={control}
            name="receberCobranca"
            rules={{
              required: true,
            }}
            render={({ field, isInvalid }) => (
              <RadioGroup value={field.value} onChange={field.onChange} mb={8}>
                <Radio isInvalid={isInvalid} value={"s"} mb={4} mr={8}>
                  Sim
                </Radio>
                <Radio isInvalid={isInvalid} value={"n"}>
                  Não
                </Radio>
              </RadioGroup>
            )}
          />
        </Box>
        <Box as={Row} gutter={16} mb={2}>
          <Box as={Col} xs={24}>
            <Field
              control={control}
              label="Categorias que o inquilino paga"
              name="categoriasDistribuicao"
              render={({ field, isInvalid }) => (
                <SelectContaCategoria
                  disableNotClassifiableNodes
                  multiple
                  placeholder="Selecione"
                  size="large"
                  isInvalid={isInvalid}
                  {...field}
                />
              )}
            />
          </Box>
        </Box>

        <Box display="flex" justifyContent="flex-end" flex={1} mt={8}>
          <PrimaryButton
            type="button"
            isLoading={isLoadingSave || isLoading || isFetching}
            onClick={_handleSubmit(handleSubmit)}
            minWidth={"120px"}
          >
            Salvar
          </PrimaryButton>
        </Box>
      </form>
    </CardDefault>
  );
}
